import 'twin.macro';
import LoadingElement from '../loading-element';
import tw from 'twin.macro';

const PrimaryButton = ({ text, handleClick, isSubmitting, disable, ...rest }) => {
  return (
    <button
      tw="bg-secondary-color text-sm px-4 py-2 transition-all duration-500 rounded-[10px] font-bold border-[1px] border-[#6A7920]"
      className="primary-button"
      onClick={handleClick}
      css={
        disable
          ? tw`bg-[#B8B8B8] border-[#B8B8B8] text-[#E4E7EB] cursor-not-allowed`
          : tw`bg-secondary-color border-[#6A7920]`
      }
      disabled={disable}
      {...rest}
    >
      {isSubmitting ? (
        <div tw="flex justify-center items-center">
          <LoadingElement width={28} height={28} />
        </div>
      ) : (
        <p>{text}</p>
      )}
    </button>
  );
};
export default PrimaryButton;
